


import firebaseApp from './firebaseApp'
import 'firebase/firestore'

const firestore = firebaseApp.firestore();
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// firestore.settings(settings);

export default firestore